import { useEffect, useState } from "react";
import { ref, onValue, off } from "firebase/database";
import { ICallPayload } from "types/auth";
import useFirebase from "hooks/useFirebase";

const useCallListener = (callId: string | null | undefined) => {
  const [callData, setCallData] = useState<ICallPayload | null>(null);
  const { database } = useFirebase();

  useEffect(() => {
    if (!database || !callId) return;

    const callRef = ref(database, `video-calls/${callId}`);

    const unsubscribe = onValue(callRef, (snapshot) => {
      if (snapshot.exists()) {
        setCallData(snapshot.val() as ICallPayload);
      } else {
        setCallData(null); // Call might be deleted or unavailable
      }
    });

    return () => off(callRef, "value", unsubscribe); // Cleanup listener
  }, [database, callId]);

  return callData;
};

export default useCallListener;
